export function todayISO() {
    return new Date().toISOString().slice(0, 10);
}

export function formatDate(date) {
    if (!date) return "—";
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
}

export function formatDateTime(value) {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    return date.toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });
}

export function formatPatientName(row) {
    const firstName = row?.prenom
        ? row.prenom.charAt(0).toUpperCase() + row.prenom.slice(1).toLowerCase()
        : "";
    return `${row?.nom || ""} ${firstName}`.trim() || "Patient sans nom";
}

export function patientInitials(row) {
    return `${row?.prenom?.[0] || ""}${row?.nom?.[0] || ""}`.toUpperCase() || "?";
}

export function normalizeSearch(value) {
    return String(value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
}

export function apiErrorMessage(error, fallback) {
    const status = error?.response?.status;
    const serverMessage = error?.response?.data?.message || error?.response?.data?.error;
    if (status === 404) return `${fallback} Route API introuvable: le backend doit probablement être redémarré/rebuildé.`;
    if (status === 403) return `${fallback} Droits insuffisants ou pharmacie superadmin non sélectionnée.`;
    if (status === 401) return `${fallback} Session refusée par le backend.`;
    if (serverMessage) return `${fallback} ${serverMessage}`;
    return fallback;
}

export function escapeHtml(value) {
    return String(value ?? "")
        .replaceAll("&", "&amp;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;")
        .replaceAll("\"", "&quot;")
        .replaceAll("'", "&#039;");
}

export function formatFileSegment(value) {
    return String(value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-zA-Z0-9]+/g, "-")
        .toLowerCase()
        .split("-").filter(Boolean).join("-") || "controle";
}

export function dateInputValue(date) {
    return date ? String(date).slice(0, 10) : "";
}
